import type { OptionState } from "./OptionButton";

// Вид варианта в выборе: до ответа — выбран или нет; после — верный, выбранный «почти»
// (`close_ids`), ошибочный выбор или в стороне. Среди нескольких верных невыбранный
// верный — «пропущен».
export const optionState = (
  picked: boolean,
  correct: boolean,
  graded: boolean,
  multi = false,
  close = false,
): OptionState => {
  if (!graded) {
    return picked ? "picked" : "idle";
  }
  if (correct) {
    return multi && !picked ? "missed" : "right";
  }
  if (picked) {
    return close ? "close" : "wrong";
  }
  return "dim";
};
